import { claimApi } from "@/main/api";
import useAsyncModalConfirm from "@/main/components/shared/asyncModalConfirm/asyncModalConfirm";
import { useThreeDotsClaimContext } from "@/main/screens/claim/searchClaim/gridSearchClaim/rowSearchClaim/collapseSearchClaim/headerCollapseSearchClaim/threeDotsClaim/contex";
import { Controls } from "@/main/services/constants/constantsControl";
import { getTranslateByKey, isShowControlByElementId } from "@/main/services/utils";
import { MenuItem } from "@mui/material";
import { toast } from "react-toastify";

interface IThreeDotsClaimSendUpdates {
	guidClaim: string;
	showSendUpdatesButton: boolean;
}

function ThreeDotsClaimSendUpdates({ guidClaim, showSendUpdatesButton }: Readonly<IThreeDotsClaimSendUpdates>) {
	const { setAnchorEl } = useThreeDotsClaimContext();
	const [getConfirmationSendUpdates, ModalConfirmationSendUpdates] = useAsyncModalConfirm();

	const showSendUpdates = isShowControlByElementId(Controls.IdSendUpdatesSearchClaim) && showSendUpdatesButton;

	async function handleClickSendUpdates() {
		const confirmed = await getConfirmationSendUpdates(getTranslateByKey("information.confirmSendUpdates"));
		if (!confirmed) return;

		setAnchorEl(null);

		claimApi
			.addSendUpdateQueue({
				guidClaim,
			})
			.then((res) => {
				if (res.data) {
					toast.success(getTranslateByKey("procurementHistoricalAction.SendUpdatesManuallyQueued"));
				}
			});
	}

	if (!showSendUpdates) return;

	return (
		<>
			<MenuItem id={`id-option-button-sendUpdates`} onClick={handleClickSendUpdates}>
				{getTranslateByKey("integrationInterface.sendUpdates")}
			</MenuItem>
			<ModalConfirmationSendUpdates />
		</>
	);
}

export { ThreeDotsClaimSendUpdates };
